export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-services-item.vue?vue&type=template&id=47fc595e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-services-item/lk-services-item.vue?vue&type=template&id=47fc595e&
// module id = 1056
// module chunks = 0